<template>
  <svg
    :width="px(size)"
    :height="px(size)"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    :stroke-width="stroke"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="mh-icon"
    aria-hidden="true"
    v-html="inner"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { ICON_PATHS, type IconName } from './icon-paths'

const props = withDefaults(
  defineProps<{
    name: IconName
    size?: number | string
    stroke?: number | string
  }>(),
  { size: 24, stroke: 2 },
)

const inner = computed(() => ICON_PATHS[props.name] ?? '')
const px = (v: number | string) => (typeof v === 'number' ? `${v}` : v)
</script>

<style scoped>
.mh-icon { display: block; flex-shrink: 0; }
</style>
